import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import type { MachineContext } from '../../utils/state-machine';
import { createIdDocMachine } from '../../utils/state-machine';
export type IdDocMachineArgs = {
  args: MachineContext;
  initState?: string;
};
const useLocalIdDocMachine = t0 => {
  const $ = _c(3);
  const {
    args,
    initState
  } = t0;
  let t1;
  if ($[0] !== args || $[1] !== initState) {
    t1 = () => createIdDocMachine(args, initState);
    $[0] = args;
    $[1] = initState;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMachine(t1);
};
export const [MachineProvider, useIdDocMachine] = constate(useLocalIdDocMachine);
export default MachineProvider;